import React, { Component } from 'react';
import { HashRouter, Route, Switch } from 'react-router-dom';

import Home from './Pages/Home/Home';
import MLA from './Pages/MLA/MLA';
import School from './Pages/School/School';
import Tax from './Pages/Tax/Tax';
import Teachers from './Pages/Teachers/Teachers';
import Travel from './Pages/Travel/Travel';
import Tuition from './Pages/Tuition/Tuition';

class AppRouter extends Component {
  render() {
    return (
      <HashRouter>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/mla" component={MLA} />
          <Route exact path="/school" component={School} />
          <Route exact path="/tax" component={Tax} />
          <Route exact path="/teachers" component={Teachers} />
          <Route exact path="/travel" component={Travel} />
          <Route exact path="/tuition" component={Tuition} />
          <Route path={null} component={Home} />
        </Switch>
      </HashRouter>
    );
  }
}

export default AppRouter;
